import TextLoading from "./textLoading";

export default TextLoading;

